import yup from "../../../../utils/yup-extended";
import {
  createProductBasicFormStepFormValidationSchema,
  CreateProductBasicFormStepFormValues,
} from "../../create-product/multi-step/basic-form/schema-validation";
import {CoverImagesItemResponse} from "../../../../react-query-hooks/products/types";

export const editProductBasicFormStepFormValidation = yup.object().shape({
  cover_images: yup
    .array()
    .min(1, "Add at least one image")
    .max(5, "You can only add a maximum of 5 images"),
});

export const editProductBasicFormStepFormValidationSchema =
  createProductBasicFormStepFormValidationSchema.concat(
    editProductBasicFormStepFormValidation
  );

export type EditProductBasicFormStepFormValuesYup = yup.InferType<
  typeof editProductBasicFormStepFormValidationSchema
>;

export type EditProductBasicFormStepFormValues = CreateProductBasicFormStepFormValues & {
  cover_images: CoverImagesItemResponse[];
};
